import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';

const ValidarToken = () => {
  const navigate = useNavigate();

  const session = localStorage.getItem('token_A');

  const params = useParams();

  const token = params.token;

  useEffect(() => {
    if (session !== null) navigate('/errors/sesion-iniciada');
  }, [session]);

  const getData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}/invitations/${token}`
      );
      const data = await response.data;
      return data;
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getData()
      .then(invitacion => {
        const date = new Date();

        const ahora = date.getSeconds();

        const expiredAt = invitacion?.expired_at;

        const expires = new Date(expiredAt);

        const isExpired = ahora >= expires;

        if (expiredAt && !isExpired) {
          navigate(`/confirmar-registro/${token}`);
        } else if ((expiredAt && isExpired) || invitacion === '') {
          navigate('/errors/invitacion-invalida');
        } else {
          navigate('/errors/invitacion-invalida');
        }
      })
      .catch(() => {
        navigate('/errors/invitacion-invalida');
      });
  }, []);

  return <div></div>;
};

export default ValidarToken;
